module.exports = __webpack_public_path__ + "img/FPTemp3.b571992a.png";